import React from 'react';
import { AnalyticsProvider } from 'telia-front-react';
import { useInsight } from '@teliaee/analytics-dom';

interface Props {
  children?: React.ReactNode;
}

const AnalyticsWrapper = (props: Props) => {
  const insight = useInsight();

  return (
    <AnalyticsProvider
      event="AutoEvent"
      page={document.title}
      onPush={async (data) => {
        window.dataLayer?.push({
          event: data.event,
          eventCategory: data.page,
          eventLabel: data.id,
          eventAction: data.group,
        });

        insight.collect({ data });
      }}
    >
      {props.children}
    </AnalyticsProvider>
  );
};

export default AnalyticsWrapper;
